import * as React from 'react';
import { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import Form from '../../components/auth/ResetForm';
import { setNewPassword, validateResetCode } from "~/apps/shared/actions/passwordReset";
import Loader from "~/common/components/Loader";
import { navigate } from "~/router";

const ResetFormEmail: FC<any> = props => {
  const { passwordReset, dispatch, code } = props;

  console.log(code);

  const onSubmit = (values) => {
    dispatch(setNewPassword(code, values));
  }

  useEffect(() => {
    dispatch(validateResetCode(code)).catch(() => {
      navigate("login");
    })
  }, []);

  if (passwordReset.loading) {
    return  <Loader className="load--ol" />;
  }

  return (
    <Form
      onSubmit={onSubmit}
      error={passwordReset.errorMessage}
      submitting={passwordReset.loading}
      success={passwordReset.successReset}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    passwordReset: state.shared.passwordReset,
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetFormEmail);
